import { IField } from '@eventr/common'
import { Gutters } from '@eventr/common-storybook'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { ISubPage } from '../../../data/Data'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { NavigationView } from '../../layout/NavigationView'
import { EditMembersItem } from '../editComponents/EditMembersItem'

interface IEditMemberItemPageProps {
    subPage: ISubPage
    _id?: string
}
export const EditMembersItemPage = ({
    subPage,
    _id,
}: IEditMemberItemPageProps) => {
    const { fields } = useBoundStore(
        useShallow((s) => {
            return {
                fields: s.fields,
            }
        })
    )
    const field = useMemo(() => {
        return fields?.find((field: IField) => {
            return field.id.toString() === subPage.fieldId.toString()
        })
    }, [fields, subPage.fieldId])

    return (
        <NavigationView
            usePageTransition
            navigationBarTitle={i18n.t('edit-members.edit-item-members')}
            backButtonAction={() => {
                window.goBack()
            }}
            // navigationBarSubtitle={eventTitle()}
            // navigationBarTrailing={[actions()]}
        >
            <Gutters>
                <EditMembersItem field={field} _id={_id} />
            </Gutters>
        </NavigationView>
    )
}
